import React from "react";

const CurrencyHeader = ({ sources }) => {
  return (
    <thead>
      <tr>
        <th>Currency</th>
        <div className="admin_exchange_header">
          {sources.map((source) => (
            <div key={source} className="admin_exchange_source">
              <th> {source} </th>
              <div className="admin_exchange_buy_sell">
                <h4>Buy</h4>
                <h4>Sell</h4>
              </div>
            </div>
          ))}
        </div>
        <th>Actions</th>
      </tr>
    </thead>
  );
};

export default CurrencyHeader;
